import { FGIcons, FGStack, FGStackItem, FGTile, FGTypography } from '@fg/design-system';
import { IActiveGroup } from 'interfaces';
import { map } from 'lodash/fp';
import React from 'react';

type Props = {
    groups?: IActiveGroup[];
    selectedGroup?: string;
    onGroupClick: (id: string) => void;
};
const NewCountryPickerGroupSection = React.memo((props: Props) => {
    return (
        <div style={{ maxHeight: 180, overflowY: 'auto' }}>
            <FGStack direction="column" gap={0}>
                {map((group: IActiveGroup) => {
                    return (
                        <FGStackItem key={group.id}>
                            <FGTile
                                data-testid="country-group-option"
                                appearance="secondary"
                                padding="small"
                                style={{ width: '100%' }}
                                onClickCapture={e => {
                                    e.stopPropagation();
                                    props.onGroupClick(group.id);
                                }}>
                                <FGStack
                                    gap={0}
                                    style={{ width: '100%' }}
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <FGTypography
                                        color="strong"
                                        tag="p"
                                        variant="body3-long">
                                        {group.name}
                                    </FGTypography>
                                    <FGIcons icon="RightArrow" />
                                </FGStack>
                            </FGTile>
                        </FGStackItem>
                    );
                }, props.groups)}
            </FGStack>
        </div>
    );
});

export default NewCountryPickerGroupSection;
